export default __webpack_public_path__ + "static/media/aboutimg3.b60b19a0.webp";